module.exports = "/_next/static/images/Hero@2x-b51fb8825ff2085bdee42956286696d6.webp";